module.exports = __webpack_public_path__ + "img/1492833196.2ac4df7c.jpg";